function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import React, { useEffect, useState, useContext } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import { Row } from 'reactstrap';
import { _translate, WeverCoreContext, _Notifications } from "../../../../services/core";
import { useWorkFlow } from "../../../contexts/workflow";
import Collector from "../../../../services/collector";
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import calendarFc from "./calendar.fc";
var localizer = momentLocalizer(moment);
var CalendarWever = function CalendarWever(props) {
  var onChange = props.onChange,
    index = props.index;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    setLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    events = _useState4[0],
    setEvents = _useState4[1];
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var _useContext = useContext(WeverCoreContext),
    locale = _useContext.locale;
  var currentOrder = collector.currentOrder,
    responses = collector.responses,
    currentQuestion = collector.currentQuestion;
  var publicParameters = currentQuestion.publicParameters;
  var minDate = publicParameters.min_date;
  var maxDate = publicParameters.max_date;
  var exclude = publicParameters.exclude;
  var dateOnly = publicParameters.date_only;
  var maxSelection = publicParameters.max_selection ? parseInt(publicParameters.max_selection) : null;
  var days = publicParameters.days ? JSON.parse(publicParameters.days) : null;
  var min = minDate ? new Date(minDate) : null;
  var max = maxDate ? new Date(maxDate) : null;
  dateOnly = dateOnly === 'true';
  var handleSelectEvent = function handleSelectEvent(e) {
    var newEvents = _toConsumableArray(events);
    var indexFound = null;
    newEvents.forEach(function (ev, indexEv) {
      var evStart = ev.start;
      if (!evStart.toDateString) {
        evStart = new Date(evStart);
      }
      if (evStart.toDateString() === e.start.toDateString()) {
        indexFound = indexEv;
      }
    });
    if (null !== indexFound) {
      newEvents.splice(indexFound, 1);
    }
    setEvents(newEvents);
  };
  var handleSelectSlot = function handleSelectSlot(e) {
    var slot = e.slots[0];
    if (!slot) {
      return;
    }
    setLoading(true);
    var year = slot.getFullYear();
    var month = slot.getMonth() + 1;
    var day = slot.getDate();
    var date = "".concat(year, "-").concat(month < 10 ? '0' : '').concat(month, "-").concat(day < 10 ? '0' : '').concat(day);
    var start = new Date("".concat(date, "T00:00:00"));
    if (calendarFc.isExcluded(start, {
      min: min,
      max: max,
      exclude: exclude,
      days: days
    })) {
      _Notifications.warning(_translate('collectorapp_calendar_conflict'), _translate('collectorapp_date_not_authorized'));
      return;
    }
    if (maxSelection && maxSelection > 1 && events.length >= maxSelection) {
      _Notifications.warning(_translate('collectorapp_calendar_conflict'), _translate('collectorapp_max_date_selected'));
      return;
    }
    var indexFound = null;
    events.forEach(function (ev, indexEv) {
      var evStart = ev.start;
      if (!evStart.toDateString) {
        evStart = new Date(evStart);
      }
      if (evStart.toDateString() === start.toDateString()) {
        indexFound = indexEv;
      }
    });
    var newEvents = maxSelection > 1 || null !== indexFound ? _toConsumableArray(events) : [];
    if (null === indexFound) {
      newEvents.push({
        title: /*#__PURE__*/React.createElement(React.Fragment, null, _translate('collectorapp_selected')),
        className: 'selected c1 c2',
        start: new Date("".concat(date, "T00:00:00")),
        end: new Date("".concat(date, "T23:59:00")),
        allDay: true,
        resource: null
      });
    } else {
      newEvents.splice(indexFound, 1);
    }
    var listElement = {};
    newEvents.forEach(function (ev, index) {
      var slot = ev.start;
      var year = slot.getFullYear();
      var month = slot.getMonth() + 1;
      var day = slot.getDate();
      var date = "".concat(year, "-").concat(month < 10 ? '0' : '').concat(month, "-").concat(day < 10 ? '0' : '').concat(day);
      listElement["e_".concat(index)] = dateOnly ? date : ev.start;
    });
    setEvents(newEvents);
    setLoading(false);
    onChange({}, listElement, null, index);
  };
  var init = function init() {
    var responsesFromHistoric = Collector.getCurrentOrderResponses(currentOrder, responses);
    var savedResponses = responsesFromHistoric === null || responsesFromHistoric === void 0 ? void 0 : responsesFromHistoric.responses;
    if (savedResponses) {
      var newEvents = [];
      Object.keys(savedResponses).forEach(function (key) {
        var startDate = savedResponses[key];
        var endDate = startDate;
        if (endDate.setHours) {
          endDate.setHours(23, 59, 0);
        }
        newEvents.push({
          title: /*#__PURE__*/React.createElement(React.Fragment, null, _translate('collectorapp_selected')),
          className: 'selected c1 c2',
          start: startDate,
          end: endDate,
          allDay: true,
          resource: null
        });
      });
      setEvents(newEvents);
    }
  };
  useEffect(function () {
    init();
  }, [responses]);
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Calendar, {
    culture: locale,
    components: calendarFc.getComponents(days, exclude, min, max, events)
    //   defaultDate={new Date(2022, 3, 1)}
    ,
    events: events,
    localizer: localizer,
    messages: calendarFc.getMessages(),
    onSelectSlot: function onSelectSlot() {
      return handleSelectSlot.apply(void 0, arguments);
    },
    onSelectEvent: handleSelectEvent,
    selectable: true,
    longPressThreshold: 10,
    style: {
      height: '500px',
      width: '100%'
    },
    views: ['month']
  }));
};
CalendarWever.propTypes = {
  onChange: PropTypes.func.isRequired,
  elements: PropTypes.arrayOf(PropTypes.shape({}))
};
CalendarWever.defaultProps = {
  elements: [],
  responses: {}
};
export default CalendarWever;